import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './FiltersTabs.css';

export interface IFiltersTabsProps {
  items: IFiltersTabProps[];
}

export interface IFiltersTabProps {
  label: string;
  url: string;
  isSelected: Boolean;
  clickHandler(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void;
}

export class FiltersTabs extends React.Component<IFiltersTabsProps> {
  public render() {
    return (
      <ul className={styles['list']} data-mark="FiltersTabs">
        {this.props.items.map(item => (
          <li
            key={`item_${item.label}`}
            {...mergeStyles(styles['list-element'], item.isSelected && styles['list-element--active'])}
          >
            <a href={item.url} onClick={event => item.clickHandler(event)}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    );
  }
}
